import { GatewayImageUploadPayload } from '@/api/models/GatewayImage';

interface IBuildGatewayImageUploadPayloadProps {
  playerId: number;
  ownerRowGuid: string;
  photoId: string;
  data: string;
}

export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject(new Error('Failed to convert image to base64.'));
        return;
      }

      resolve(result.split(',')[1] || '');
    };

    reader.onerror = () => reject(reader.error || new Error('Failed to read image.'));
    reader.readAsDataURL(blob);
  });
};

export const createImageFile = (photo: Blob, fileName: string) => {
  if (photo instanceof File) {
    return photo;
  }

  return new File([photo], fileName, {
    type: photo.type || 'image/jpeg',
    lastModified: Date.now(),
  });
};

export const buildGatewayImageUploadPayload = ({ playerId, ownerRowGuid, photoId, data }: IBuildGatewayImageUploadPayloadProps): GatewayImageUploadPayload => ({
  playerId,
  clubId: ownerRowGuid,
  id: photoId,
  data,
});
